import { render, staticRenderFns } from "./Opzeggen.vue?vue&type=template&id=0eb08d22"
import script from "./Opzeggen.vue?vue&type=script&lang=js"
export * from "./Opzeggen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports